// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cloud_functions: 'https://southamerica-east1-inversu-ecommerce-staging.cloudfunctions.net',
  storage: 'https://storage.googleapis.com/upload/storage/v1/b/inversu-staging-public',
  firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/inversu-staging-public',
  firebaseConfig: {
    apiKey: "AIzaSyCBd0oE5giI8tAAclm9Cotjh8UtES11vRI",
    authDomain: "inversu-ecommerce-staging.firebaseapp.com",
    projectId: "inversu-ecommerce-staging",
    storageBucket: "inversu-ecommerce-staging.appspot.com",
    messagingSenderId: "958478123362",
    appId: "1:958478123362:web:ba587571ae75ea7af4ec3b",
    measurementId: "G-JG5SJFQ02V"
  },
  telegram_bot: 'inversu_global_bot',
  pagseguro: {
    public_key: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvGIaiFVCVPK4tCAFJXMguJ/TR/y4HhU0nPSCOpK393hbMHMQX9t7Y6gA+cpsUBIQeXIi7ox2XPYGDq3tZvJuWFrokg6zSWBN0JLiAMmi87J9rYQs+OMe8uADM97gDsk7RwhADfTcg7qa95qKeOYrACy3HV/uvPIR9S+6YzXHfK9OXo380kwJCHX6uC8Uwci7dMCYxYqe5G6HZVE4OFLuuEnJ7hKoSXNZQr0pMbYKV8UKQB2zq0rCRjPQLLS5XvqMOPAK724BhWN+tBeXHpKCrVl8x9A5+OoJpaxP8o7vwmVG57+rTJdX4fq9fK5ZUXcsQKZnVDebCbwGJY6NILBsRQIDAQAB"
  }
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
